<template>
	<div class="Complaint">
		<div class="Complaint_container">
			<div class="Complaint_input">
				<div class="Complaint_input_left">标题</div>
				<div class="Complaint_input_right">
					<input v-model="title" type="type" name="" id="" value="" placeholder="请输入描述问题" />
				</div>
			</div>
		</div>
		<div class="release_describe">
			<div class="release_type_top">详细描述</div>
			<div class="release_type_bottom">
				<div class="file_container">
					<textarea @input="file_change" v-model="describe" class="file_text" name="file_text" rows="" maxlength="500" cols="" placeholder="请输入详细描述"></textarea>
				</div>
				<div class="file_num"><span>{{file_num}}</span>/500</div>
			</div>
		</div>
		<div class="Complaint_container">
			<div class="Complaint_input">
				<div class="Complaint_input_left">姓名</div>
				<div class="Complaint_input_right">
					<input v-model="name" type="type" name="" id="" value="" placeholder="请输入姓名" />
				</div>
			</div>
		</div>
		<div class="Complaint_container">
			<div class="Complaint_input" style="margin-bottom:70px;">
				<div class="Complaint_input_left">联系方式</div>
				<div class="Complaint_input_right">
					<input v-model="phone" type="type" name="" id="" value="" placeholder="请输入手机号" />
				</div>
			</div>
		</div>
		<div class="release_btn" v-show="showBtn">
			<div class="release_btn_cli" @click="Submission">提交</div>
		</div>
		<div class="appointment_success" v-show="success">
			<div class="success_center">
				<img v-if="success_img" src="../assets/success.png" />
				<img v-if="!success_img" src="../assets/buttom_x.png" />
				<p>{{success_text}}</p>
				<p>请耐心等待审核</p>
				<div @click="determine">确定</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { wclient } from '../../static/wclient-mobile.js'
	export default {
		name: 'Complaint',
		data() {
			return {
				title: "",
				clientHeight: document.documentElement.clientHeight,
				showBtn: true,
				baseUrl: "",
				access_token: "",
				baseUrlOne: "",
				success: false,
				success_img: false,
				success_text: "",
				file_num: 0,
				describe: "",
				name: "",
				phone: "",
				name_reg: "",
				phoneReg: ""
			}
		},
		methods: {
			determine() {
				var that = this;
				if(that.success_text == "提交成功") {
					that.title='';
					that.describe='';
					that.name='';
					that.phone='';
					that.file_num=0;
					that.success = false;
				} else {
					that.success = false;
				}
			},
			file_change() {
				var that = this;
				that.file_num = that.describe.length;
				if(that.describe.length >= 500) {
					that.file_num = 500;
					that.describe = that.describe;
				}
			},
			Submission() {
				var that = this;
				if(that.title == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入标题';
				} else if(that.describe == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入详细描述';
				} else if(that.name == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入姓名';
				} else if(!that.name_reg.test(that.name)) {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入正确的姓名';
				} else if(that.phone == '') {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入手机号';
				} else if(!that.phoneReg.test(that.phone)) {
					that.success = true;
					that.success_img = false;
					that.success_text = '请输入正确的手机号';
				} else {
					wclient.view.showLoading();
					wclient.crossdomain = true; // 启动跨域支持（多模块组合应用）
					wclient.ajax({
						type: "GET",
						url: that.baseUrl + '?ugi=complaint&action=releasetrackgrecord',
						dataType: "json",
						async: true,
						data: {
							access_token: that.access_token,
							title: that.title,
							content: that.describe,
							name: that.name,
							phone: that.phone
						},
						success: function(data) {
							wclient.view.hideLoading();
							if(data.code == 'A00006') {
								that.success = true;
								that.success_img = true;
								that.success_text = '提交成功';
							} else {
								that.success = true;
								that.success_img = false;
								that.success_text = data.errmsg;
							}

						}
					});
				}
			}
		},
		mounted() {
			var that = this;
			var publicUrl = window.location.hostname;
			if(publicUrl == "localhost") {
				var baseUrl = "https://www.xiangshan1949.cn/reception/ajax";
				var baseUrlOne = "https://www.xiangshan1949.cn";
			} else if(publicUrl == "m.xs.weapi.org") {
				var baseUrl = "http://operation.xs.weapi.org/reception/ajax";
				var baseUrlOne = "http://xs.weapi.org";
			} else {
				var baseUrl = "https://www.xiangshan1949.cn/reception/ajax";
				var baseUrlOne = "https://www.xiangshan1949.cn";
			}
			that.baseUrl = baseUrl;
			that.baseUrlOne = baseUrlOne;
			that.name_reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
			that.phoneReg = /^1[3456789]\d{9}$/;
			window.onresize = () => {
				if(this.clientHeight > document.documentElement.clientHeight) {
					this.showBtn = false
				} else {
					this.showBtn = true
				}

			}
			if(localStorage.getItem('access_token') == null) {
				sessionStorage.setItem('token_type', 'Complaint')
				that.$router.push({
					name: 'Logo'
				})
			} else {
				$.ajax({
					type: "GET",
					url: that.baseUrlOne + "/ajax?ugi=loginUgi&action=logininfo",
					dataType: "json",
					async: true,
					data: {
						access_token: localStorage.getItem('access_token')
					},
					success: function(res) {
						if(res.code == 'A00006') {
							that.access_token = localStorage.getItem('access_token');
						} else {
							sessionStorage.setItem('token_type', 'Complaint')
							that.$router.push({
								name: 'Logo'
							})
						}
					}
				});
			}
		}
	}
</script>

<style scoped>
	.Complaint {
		width: 100%;
		margin: 0 auto;
		height: 100%;
		-webkit-overflow-scrolling: touch;
		background: white;
	}
	
	.Complaint_container {
		width: 90%;
		margin: 0 auto;
	}
	
	.release_btn {
		width: 100%;
		position: fixed;
		bottom: 0;
		left: 0;
		background: white;
		padding: 15px 0;
		border-top: 1px solid #DBDBDB;
	}
	
	.release_btn_cli {
		width: 70%;
		margin: 0 auto;
		background: linear-gradient(255deg, rgba(228, 4, 4, 1), rgba(255, 56, 56, 1));
		line-height: 40px;
		text-align: center;
		color: white;
		border-radius: 20px;
	}
	
	input::-webkit-input-placeholder {
		/* WebKit browsers */
		color: #B1B1B1;
	}
	
	input:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #B1B1B1;
	}
	
	input::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #B1B1B1;
	}
	
	input::-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #B1B1B1;
	}
	
	.appointment_success {
		width: 110%;
		height: 100%;
		background: rgba(0, 0, 0, 0.54);
		position: fixed;
		top: 0;
		left: 0;
	}
	
	.success_center {
		margin-top: 35%;
		background: white;
		width: 60%;
		margin-left: 15%;
		padding-top: 10px;
		border-radius: 10px;
	}
	
	.success_center img {
		width: 23%;
		margin-left: 39%;
		margin-top: 30px;
	}
	
	.success_center p:nth-of-type(1) {
		width: 80%;
		color: black;
		font-size: 17px;
		font-weight: 600;
		text-align: center;
		margin: 20px auto 0;
	}
	
	.success_center p:nth-of-type(2) {
		width: 100%;
		color: #A4A4A4;
		font-size: 16px;
		text-align: center;
		margin-top: 5px;
		letter-spacing: 1px;
	}
	
	.success_center div {
		width: 100%;
		line-height: 45px;
		text-align: center;
		font-weight: 600;
		color: rgba(228, 4, 4, 1);
		border-top: 1px solid #eee;
		margin-top: 25px;
	}
	
	.Complaint_input {
		width: 100%;
		border-bottom: 1px solid #DBDBDB;
		display: flex;
		justify-content: space-between;
		line-height: 60px;
		font-size: 16px;
	}
	
	input {
		border: none;
		outline: none;
		text-align: right;
		font-size: 16px;
	}
	
	.release_describe {
		width: 90%;
		padding: 0 5%;
	}
	
	.release_type_top {
		width: 100%;
		padding: 15px 0;
		font-size: 15px;
	}
	
	.release_type_bottom {
		width: 100%;
		border: 1px solid rgba(222, 222, 222, 1);
	}
	
	.file_container {
		width: 100%;
		position: relative;
	}
	
	.file_text {
		display: block;
		width: 90%;
		height: 160px;
		background: white;
		outline: none;
		padding: 20px 5% 0;
		font-size: 14px;
		overflow: hidden;
		border-radius: 4px;
		resize: none;
		line-height: 20px;
		border: none;
		overflow-y: scroll;
	}
	
	.file_num {
		color: rgba(180, 180, 180, 1);
		width: 90%;
		text-align: right;
		line-height: 45px;
		margin: 0 auto;
	}
</style>


// WEBPACK FOOTER //
// src/components/Complaint.vue